import { navigate } from 'gatsby';
import React, { FC } from 'react';

import BasicText from '@ui/atoms/BasicText';
import Breadcrumb from '@ui/atoms/Breadcrumb';
import FlexColumn, { IFlexColumn } from '@ui/atoms/FlexColumn';
import HeadingText from '@ui/atoms/HeadingText';

import BillSummaryCard from '@ui/organisms/BillSummaryCard';

import fullWidth from '@ui/styled/FullWidth';

import { IMemberBill } from '@hooks/useMemberBills';

import { IPageProps } from '@folx-types/flow-steps';

export interface IBillsListStepContent {
	title: string;
	disclaimer: string;
	breadcrumbLabel: string;
	emptyMedicationBillsText: string;
	loadMoreLabel: string;
}

interface IBillsListStepProps extends IPageProps {
	pageContent: IBillsListStepContent;
	bills?: IMemberBill[];
}

const FullWidthColumn = fullWidth<IFlexColumn>(FlexColumn);

const BillsListStep: FC<IBillsListStepProps> = ({ bills, pageContent }) => {
	const { title, breadcrumbLabel, emptyMedicationBillsText } = pageContent;

	return (
		<FullWidthColumn gap="sm">
			<Breadcrumb href={'../'} label={breadcrumbLabel} />
			<FullWidthColumn gap="md">
				<HeadingText>{title}</HeadingText>
				{!(bills && bills.length > 0) && (
					<BasicText variant="small">{emptyMedicationBillsText}</BasicText>
				)}
				{bills &&
					bills.length > 0 &&
					bills.map((bill: IMemberBill) => (
						<BillSummaryCard
							handleClick={() => {
								bill.__typename === 'InvoiceProposal'
									? navigate(`./details/${bill.proposalId}`)
									: navigate(`./invoice/${bill.invoiceId}`);
							}}
							key={bill.__typename === 'Invoice' ? bill.invoiceId : bill.proposalId}
							bill={bill}
						/>
					))}
			</FullWidthColumn>
		</FullWidthColumn>
	);
};

export default BillsListStep;
